module.exports = __webpack_public_path__ + "img/picto-EV 2.340aacd1.svg";